import { useSiteSettings } from "@/lib/siteData";

function Row({ ariaHidden = false, items }) {
    return (
        <div
            aria-hidden={ariaHidden}
            className="flex shrink-0 items-center"
        >
            {items.map((item, i) => (
                <span key={`${item}-${i}`} className="flex shrink-0 items-center">
                    <span
                        className={`whitespace-nowrap px-8 font-display text-2xl font-extrabold uppercase tracking-wide sm:text-3xl ${
                            i % 2 === 0 ? "text-ink" : "text-stroke"
                        }`}
                    >
                        {item}
                    </span>
                    <span className="h-2.5 w-2.5 rotate-45 bg-neon-teal" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    const settings = useSiteSettings();
    const ITEMS = [
        "PASSEIOS DE JET SKI",
        "LUGARES PARADISÍACOS",
        `A PARTIR DE ${settings.hero_price}`,
        "UBATUBA • SP",
    ];

    return (
        <div
            data-testid="editorial-marquee"
            className="relative border-y border-neon-cyan/15 bg-deep/40 py-6"
        >
            <div className="marquee-track">
                <Row items={ITEMS} />
                <Row items={ITEMS} ariaHidden />
            </div>
        </div>
    );
}
